/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import { Directive } from '@angular/core';

@Directive({
  selector: 'clr-icon',
})
export class ClrIconCustomTag {
  // No behavior
  // The only purpose is to "declare" the tag in Angular
}

@Directive({
  selector: 'cds-icon',
})
export class CdsIconCustomTag {
  // No behavior
  // The only purpose is to "declare" the tag in Angular
}
